import { useState, useEffect } from 'react';
import { 
  Button,  Link, Grid, Typography, IconButton, Alert
} from '@mui/material';
import PinInput from 'react-pin-input';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';

import { checkCode, getCode, verificarCodigoRecuperacion } from '../../actions/users';
import { isEmpty } from '../common/helpers';

const FormForgetPass3 = ({
  setPasos, setCodigo, setData,
  codigo, type, data
}) => {
  const [disableSMS, setDisableSMS] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDisableBtn(codigo.length!==4);
  }, [codigo]);

  const reenviar = async () => {
    setDisableSMS(true);
    const info = {
      email: data.email,
      tel: "52".concat(data.tel),
      subject: "olvido"
    }
    const res = await getCode(type, info);
    if(res){
      setData({
        ...data,
        codigo: res.codigo
      });
    } else {
      setError("Error al reenviar el código");
    }
    setTimeout(() => {
      setDisableSMS(false)
    }, 25000);
  }
  
  // Servidor anterior (sin POST /password/verificar): el código se comprueba aquí, como antes
  const recuperarComoAntes = async () => {
    if(type === "celular"){
      const to = "52".concat(data.tel);
      const resCode = await checkCode({ phonenumber: to, code: codigo });
      return Boolean(resCode);
    }
    return data.codigo !== undefined && data.codigo !== '' && data.codigo.toString() === codigo;
  }

  const recuperar = async e => {
    e.preventDefault();
    if(codigo.length !== 4){
      return setError("Deben de ser 4 dígitos");
    }
    setDisableBtn(true);
    // El servidor comprueba el código y entrega un permiso de un solo uso para la contraseña nueva
    const res = await verificarCodigoRecuperacion({
      canal: type === "celular" ? "celular" : "email",
      dato: type === "celular" ? "52".concat(data.tel) : data.email,
      codigo
    });
    if(res.token){
      setData({
        ...data,
        token: res.token
      });
      return setPasos(4);
    }
    if(res.legado && await recuperarComoAntes()){
      return setPasos(4);
    }
    setDisableBtn(false);
    setError(res.legado ? "Código incorrecto" : res.error);
  }

  return (
    <form noValidate onSubmit={recuperar}>
      <Grid size={12}>
        <IconButton
          className="btn-icon"
          aria-label="back"
          onClick={() => setPasos(2)}
        >
          <ChevronLeftIcon />
        </IconButton>
      </Grid>
      <Grid container sx={{my:2}} spacing={{ sx: 1}}>
        <Grid size={12} className="step1" container direction="column">
          <Typography variant="h3" component="h3">¿Olvidaste tu contraseña?</Typography>
          <Typography component="p">Introduce el código recibido.</Typography>
        </Grid>
        <Grid size={12}>
          <PinInput
            length={4}
            onChange={(value) => setCodigo(value)}
          />
        </Grid>
      </Grid>
      {
        !isEmpty(error) && (
          <Alert className="mss-alert" severity="error">
            <Typography component="p" color="error.oscuro">{error}</Typography>
          </Alert>
        )
      }
      <Grid size={12} sx={{mt: 3}}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          disabled={disableBtn}
        >
          Continuar
        </Button>
      </Grid>
      <Grid container>
        <Grid size={12} sx={{mt: 3}}>
          <Typography className="link" component="p">
            <Link
              component="a"
              underline="hover"
              sx={{
                pointerEvents: disableSMS ? 'none' : 'auto',
                color: disableSMS ? 'grey.500' : 'primary.main',
                cursor: disableSMS ? 'not-allowed' : 'pointer',
                textDecoration: disableSMS ? 'none' : 'underline',
              }}
              onClick={() => reenviar()}
            >
              No recibí el código, enviar de nuevo
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </form>
  )
}

FormForgetPass3.propTypes = {
  setPasos: PropTypes.func.isRequired,
  codigo: PropTypes.any.isRequired,
  setCodigo: PropTypes.func.isRequired,
}

export default FormForgetPass3;